// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__wj9Vy","productName":"Table_productName__3bLlJ"};